import { mutationTypes, actionTypes } from '../access-keys'
import defaultStates from './month-of-statement/default-states'
import { map } from '../helpers/mapper'

export default {
  namespaced: true,
  state: defaultStates.forRoot(),
  getters: {},
  mutations: {
    [mutationTypes.monthOfStatement.RESET_STATE](state) {
      map(defaultStates.forRoot(), state)
    },
    [mutationTypes.monthOfStatement.ACTIVATE_STEP](state, step) {
      if (step > state.stepActiveTo) {
        state.stepActiveTo = step
      }
    },
    [mutationTypes.monthOfStatement.UNACTIVATE_STEP](state, step) {
      if (step < state.stepActiveTo) {
        state.stepActiveTo = step
      }
    }
  },
  actions: {
    [actionTypes.monthOfStatement.RESET_FORM]({ commit }) {
      commit(mutationTypes.monthOfStatement.RESET_STATE)
      commit(mutationTypes.monthOfStatement.step1.RESET_STATE_ROOT, null, { root: true })
      commit(mutationTypes.monthOfStatement.step2.RESET_STATE_ROOT, null, { root: true })
    }
  },
  modules: {
    step1: {
      namespaced: true,
      state: defaultStates.forStep1(),
      getters: {},
      mutations: {
        [mutationTypes.monthOfStatement.step1.RESET_STATE](state) {
          map(defaultStates.forStep1(), state)
        },
        [mutationTypes.monthOfStatement.step1.REGISTER_FORM_DATAS](state, payload) {
          state.formDatas = payload
          state.isValidated = true
        }
      },
      actions: {
        [actionTypes.monthOfStatement.step1.COMPLETE_STEP]({ commit, state }, payload) {
          commit(mutationTypes.monthOfStatement.step1.REGISTER_FORM_DATAS, payload)
          commit(mutationTypes.root.CLEAR_API_ERRORS, null, { root: true })
          commit(mutationTypes.monthOfStatement.ACTIVATE_STEP_ROOT, 2, { root: true })
        }
      }
    },
    step2: {
      namespaced: true,
      state: defaultStates.forStep2(),
      getters: {},
      mutations: {
        [mutationTypes.monthOfStatement.step2.RESET_STATE](state) {
          map(defaultStates.forStep2(), state)
        },
        [mutationTypes.monthOfStatement.step2.REGISTER_FORM_DATAS](state, payload) {
          state.formDatas = payload
          state.isValidated = true
        }
      },
      actions: {
        [actionTypes.monthOfStatement.step2.COMPLETE_STEP]({ commit, state }, payload) {
          commit(mutationTypes.monthOfStatement.step2.REGISTER_FORM_DATAS, payload)
          commit(mutationTypes.root.CLEAR_API_ERRORS, null, { root: true })
          commit(mutationTypes.monthOfStatement.ACTIVATE_STEP_ROOT, 3, { root: true })
        }
      }
    }
  }
}
